angular.module('pitch.app').controller('ContactCtrl',
    function($scope, $timeout, SiteContext, Site, SelectOfficeModal) {

        "use strict";

        $scope.slides = [{
            type: 'image',
            assets:[{
                'key':'main',
                'src': '//d3s18e4k8zu2lx.cloudfront.net/content/contact/sony_atv_nashville_office.jpg'
            }]
        }];

        SiteContext.get().then(function(r) {
            Site.get({
                id: r.id
            }, function(site) {
                $scope.site = site;
                $scope.showOffice($scope.site.offices[0]);
            });
        });

        $scope.showOffice = function(office) {
            $scope.selectedOffice = office;
        };

        $scope.selectOffice = function() {
            SelectOfficeModal.open({
                success: function(r) {
                    $scope.selectedOffice = r[1];
                }
            });
        };
    }
);



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/controllers/ContactCtrl.js